/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentHistoryStatusQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ComplianceAssessmentHistoryStatusQueryOperator");
    }

    getFixupPrototypeFunction() { return ComplianceAssessmentHistoryStatusQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentHistoryStatusQueryOperator>): ComplianceAssessmentHistoryStatusQueryOperator {
        let obj = Object.assign(new ComplianceAssessmentHistoryStatusQueryOperator(), model);
        ComplianceAssessmentHistoryStatusQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentHistoryStatusQueryOperator>): ComplianceAssessmentHistoryStatusQueryOperator {
        if (!model) return null;
        return ComplianceAssessmentHistoryStatusQueryOperator.newInstance(<ComplianceAssessmentHistoryStatusQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentHistoryStatusQueryOperator) {
        if (!obj) return;

        models.ComplianceAssessmentHistoryStatusQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentHistoryStatusQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceAssessmentHistoryStatusQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Assessment statuses to filter assessment history
     */
    statuses: Array<models.AssessmentStatus>;

}
